import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {esNormativaV2} from '../../../../utils/normativa.utils'
import useCatalogoOpcional, {OpcionCatalogo} from './useCatalogoOpcional'

interface PropiedadesFilaCatalogoV2DTE {
  endpoint: string
  etiqueta: string
  codigo: any
}

export default function FilaCatalogoV2DTE({
  endpoint,
  etiqueta,
  codigo,
}: PropiedadesFilaCatalogoV2DTE) {
  const {datosEmisor} = useSelector((state: State) => state.catalogos)
  const normativaV2 = esNormativaV2(datosEmisor)
  const {opciones} = useCatalogoOpcional(endpoint, normativaV2)

  if (!normativaV2) return null

  const valor = `${codigo ?? ''}`.trim()
  const nombre = opciones.find((opcion: OpcionCatalogo) => opcion.codigo === valor)?.valor

  return (
    <tr>
      <td>{etiqueta}:</td>
      <td>{nombre ?? (valor || '--')}</td>
    </tr>
  )
}
